<template>
	<div class="order-panel">
		<!-- 搜索栏 -->
		<div class="search-bar">
			<div class="search-form">
				<el-input v-model="searchForm.merchant_order_no" placeholder="商户订单号"
					class="search-input merchant-order-no" clearable prefix-icon="el-icon-document"></el-input>

				<el-input v-model="searchForm.track_number" placeholder="物流单号"
					class="search-input provider-order-no" clearable prefix-icon="el-icon-tickets"></el-input>

				<el-select v-model="searchForm.track_type" placeholder="物流商" class="search-input order-type"
					clearable>
					<el-option label="全部" :value="0"></el-option>
					<el-option label="（佳成）JCEX" :value="1"></el-option>
					<el-option label="（极速）JS" :value="2"></el-option>
					<el-option label="（小猪）PIGGY" :value="3"></el-option>
				</el-select>

				<el-select v-model="searchForm.route_type" placeholder="物流线路" class="search-input route-type"
					clearable>
					<el-option label="全部线路" :value="-1"></el-option>
					<el-option label="美国-美国" :value="0"></el-option>
					<el-option label="英国-英国" :value="1"></el-option>
					<el-option label="加拿大-加拿大" :value="2"></el-option>
					<el-option label="中国-全球" :value="3"></el-option>
				</el-select>

				<el-select v-model="searchForm.push_track" placeholder="轨迹推送状态" class="search-input push-track"
					clearable>
					<el-option label="全部状态" :value="-1"></el-option>
					<el-option label="未推送" :value="0"></el-option>
					<el-option label="推送成功" :value="1"></el-option>
					<el-option label="推送失败" :value="2"></el-option>
				</el-select>

				<el-date-picker v-model="searchForm.create_time_range" type="datetimerange"
					range-separator="至" start-placeholder="创建时间开始" end-placeholder="创建时间结束"
					clearable format="yyyy/MM/dd HH:mm" value-format="yyyy-MM-dd HH:mm:ss"
					:default-time="['00:00:00', '23:59:59']"
					class="search-input date-time-range" prefix-icon="el-icon-date"></el-date-picker>

				<el-date-picker v-model="searchForm.track_start_time_range" type="datetimerange"
					range-separator="至" start-placeholder="轨迹开始时间开始" end-placeholder="轨迹开始时间结束"
					clearable format="yyyy/MM/dd HH:mm" value-format="yyyy-MM-dd HH:mm:ss"
					:default-time="['00:00:00', '23:59:59']"
					class="search-input date-time-range"></el-date-picker>

				<el-input v-model="pageSizeInput" placeholder="每页显示" class="search-input page-size-input"
					@keyup.enter="handleSearch" @input="handlePageSizeInput" clearable></el-input>
				<el-button @click="handleReset" class="reset-btn">
					重置
				</el-button>
				<el-button type="primary" @click="handleSearch" class="search-btn" icon="el-icon-search">
					搜索
				</el-button>
				<el-button @click="handleExport" class="reset-btn export-btn" icon="el-icon-download"
					:loading="exporting">{{ exportLabel }}</el-button>
			</div>
		</div>

		<!-- 订单表格 -->
		<div class="table-container">
			<el-table :data="orderTableData" border style="width: 100%" v-loading="tableLoading"
				class="order-table" :header-cell-style="{ 
						background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
						color: '#fff',
						fontWeight: '600',
						fontSize: '14px',
						padding: '12px 8px'
					}" :cell-style="{ 
						padding: '10px 8px',
						fontSize: '13px'
					}" @selection-change="handleSelectionChange">
				<el-table-column type="selection" width="50" align="center">
				</el-table-column>

				<el-table-column prop="merchantOrderNo" label="商户订单号" align="center" min-width="120">
					<template slot-scope="scope">
						<div class="simple-cell">
							<el-tooltip v-if="scope.row.merchantOrderNo && scope.row.merchantOrderNo.length > 12"
								:content="scope.row.merchantOrderNo" placement="top">
								<span class="cell-text">
									{{ scope.row.merchantOrderNo.substring(0, 12) }}...
								</span>
							</el-tooltip>
							<span v-else class="cell-text">
								{{ scope.row.merchantOrderNo || '-' }}
							</span>
						</div>
					</template>
				</el-table-column>

				<el-table-column prop="providerOrderNo" label="服务商单号" align="center" min-width="130">
					<template slot-scope="scope">
						<div class="simple-cell">
							<span class="cell-text track-number">
								<a :href="getLinkUrl(scope.row.providerOrderNo)" target="_blank"
									rel="noopener noreferrer">
									{{ scope.row.providerOrderNo || '-' }}
								</a>
							</span>
						</div>
					</template>
				</el-table-column>

				<el-table-column prop="orderType" label="物流商" align="center" min-width="90">
					<template slot-scope="scope">
						<el-tag :type="scope.row.orderType === '1' ? 'primary' : 'success'" effect="plain"
							size="small" style="border-radius: 4px; padding: 4px 8px;">
							{{ scope.row.orderType === '1' ? 'JCEX' : 'JS' }}
						</el-tag>
					</template>
				</el-table-column>

				<el-table-column prop="routeTypeName" label="物流线路" align="center" min-width="90">
					<template slot-scope="scope">
						<el-tag :type="getRouteTagType(scope.row.route_type)" effect="plain" size="small"
							style="border-radius: 4px; padding: 4px 8px;">
							{{ scope.row.routeTypeName || '-' }}
						</el-tag>
					</template>
				</el-table-column>

				<el-table-column prop="senderAddress" label="发货地址" align="center" min-width="130">
					<template slot-scope="scope">
						<div class="address-cell">
							<div class="country-badge" v-if="scope.row.shippingCountry">
								<i class="el-icon-location"></i>
								{{ scope.row.shippingCountry }}
							</div>
							<template v-if="scope.row.formattedSenderAddress">
								<div class="address-line">
									<span class="address-label">州：</span>
									<span
										class="address-value">{{ scope.row.formattedSenderAddress.state || '-' }}</span>
								</div>
								<div class="address-line">
									<span class="address-label">城市：</span>
									<span
										class="address-value">{{ scope.row.formattedSenderAddress.city || '-' }}</span>
								</div>
								<div class="address-line">
									<span class="address-label">地址：</span>
									<el-tooltip
										v-if="scope.row.formattedSenderAddress.address && scope.row.formattedSenderAddress.address.length > 15"
										:content="scope.row.formattedSenderAddress.address" placement="top">
										<span class="address-value">
											{{ scope.row.formattedSenderAddress.address.substring(0, 15) }}...
										</span>
									</el-tooltip>
									<span v-else class="address-value">
										{{ scope.row.formattedSenderAddress.address || '-' }}
									</span>
								</div>
								<div class="address-line">
									<span class="address-label">邮编：</span>
									<span
										class="address-value">{{ scope.row.formattedSenderAddress.zipcode || '-' }}</span>
								</div>
							</template>
							<template v-else>
								<span class="cell-text">{{ scope.row.senderAddress || '-' }}</span>
							</template>
						</div>
					</template>
				</el-table-column>

				<el-table-column prop="receiverAddress" label="收货地址" align="center" min-width="130">
					<template slot-scope="scope">
						<div class="address-cell">
							<div class="country-badge" v-if="scope.row.receivingCountry">
								<i class="el-icon-location"></i>
								{{ scope.row.receivingCountry }}
							</div>
							<template v-if="scope.row.formattedReceiverAddress">
								<div class="address-line">
									<span class="address-label">州：</span>
									<span
										class="address-value">{{ scope.row.formattedReceiverAddress.state || '-' }}</span>
								</div>
								<div class="address-line">
									<span class="address-label">城市：</span>
									<span
										class="address-value">{{ scope.row.formattedReceiverAddress.city || '-' }}</span>
								</div>
								<div class="address-line">
									<span class="address-label">地址：</span>
									<el-tooltip
										v-if="scope.row.formattedReceiverAddress.address && scope.row.formattedReceiverAddress.address.length > 15"
										:content="scope.row.formattedReceiverAddress.address" placement="top">
										<span class="address-value">
											{{ scope.row.formattedReceiverAddress.address.substring(0, 15) }}...
										</span>
									</el-tooltip>
									<span v-else class="address-value">
										{{ scope.row.formattedReceiverAddress.address || '-' }}
									</span>
								</div>
								<div class="address-line">
									<span class="address-label">邮编：</span>
									<span
										class="address-value">{{ scope.row.formattedReceiverAddress.zipcode || '-' }}</span>
								</div>
							</template>
							<template v-else>
								<span class="cell-text">{{ scope.row.receiverAddress || '-' }}</span>
							</template>
						</div>
					</template>
				</el-table-column>

				<el-table-column prop="pushTrack" label="轨迹推送状态" align="center" min-width="100">
					<template slot-scope="scope">
						<el-tag :type="getPushTrackTagType(scope.row.pushTrack)" effect="light" size="small"
							style="border-radius: 12px; padding: 4px 12px; font-weight: 500;">
							{{ getPushTrackText(scope.row.pushTrack) }}
						</el-tag>
					</template>
				</el-table-column>

				<el-table-column prop="status" label="单号类型" align="center" min-width="100">
					<template slot-scope="scope">
						<el-tag :type="getStatusTagType(scope.row.status)" effect="light" size="small"
							style="border-radius: 12px; padding: 4px 12px; font-weight: 500;">
							{{ getStatusText(scope.row.status) }}
						</el-tag>
					</template>
				</el-table-column>

				<el-table-column prop="createTime" label="订单创建时间" align="center" min-width="125">
					<template slot-scope="scope">
						<div class="simple-cell">
							<span class="cell-text">{{ scope.row.createTime || '-' }}</span>
						</div>
					</template>
				</el-table-column>

				<el-table-column prop="remark" label="备注" align="center" min-width="110">
					<template slot-scope="scope">
						<div class="simple-cell">
							<el-tooltip v-if="scope.row.remark && scope.row.remark.length > 10"
								:content="scope.row.remark" placement="top">
								<span class="cell-text remark">
									{{ scope.row.remark.substring(0, 10) }}...
								</span>
							</el-tooltip>
							<span v-else class="cell-text remark">
								{{ scope.row.remark || '无' }}
							</span>
						</div>
					</template>
				</el-table-column>

				<el-table-column prop="trackStartTime" label="轨迹开始时间" align="center" min-width="125">
					<template slot-scope="scope">
						<div class="simple-cell">
							<span class="cell-text">{{ scope.row.trackStartTime || '-' }}</span>
						</div>
					</template>
				</el-table-column>

				<el-table-column prop="trackEndTime" label="轨迹结束时间" align="center" min-width="125">
					<template slot-scope="scope">
						<div class="simple-cell">
							<span class="cell-text">{{ scope.row.trackEndTime || '-' }}</span>
						</div>
					</template>
				</el-table-column>
			</el-table>

			<div class="empty-data" v-if="orderTableData.length === 0 && !tableLoading">
				<i class="el-icon-document" style="font-size: 48px; color: #c0c4cc; margin-bottom: 16px;"></i>
				<p style="font-size: 16px; color: #909399; margin: 0;">暂无订单数据</p>
				<p style="font-size: 14px; color: #c0c4cc; margin: 8px 0 0 0;">请尝试修改搜索条件或导入订单</p>
			</div>
		</div>

		<!-- 分页控件 -->
		<div class="pagination-container">
			<el-pagination @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pageSize"
				layout="total, prev, pager, next" :total="total" class="order-pagination">
			</el-pagination>
		</div>
	</div>
</template>

<script>
import { formatDateTime as fmtDateTime } from '../utils/format';
import { exportCSV } from '../utils/export';

export default {
	name: 'OrderListPanel',
	props: {
		userId: {
			type: Number,
			default: 0
		},
		activeTab: {
			type: String,
			default: '0'
		}
	},
	data() {
		return {
			searchForm: {
				merchant_order_no: '',
				track_number: '',
				track_type: 0,
				route_type: -1,
				push_track: -1,
				order_status: 0,
				create_time_range: [],
				track_start_time_range: []
			},
			pageSizeInput: '',
			tableLoading: false,
			exporting: false,
			orderTableData: [],
			currentPage: 1,
			pageSize: 10,
			total: 0,
			selectedOrderIds: [],
			selectedOrders: []
		};
	},
	watch: {
		activeTab(val) {
			if (val !== undefined) {
				this.applyStatusTab(val);
			}
		}
	},
	computed: {
		exportLabel() {
			if (this.selectedOrders.length > 0) {
				return '导出 Excel（已选 ' + this.selectedOrders.length + '）';
			}
			return '导出 Excel（' + this.total + '）';
		}
	},
	mounted() {
		this.handleSearch();
	},
	methods: {
		async apiRequest(url, data) {
			const response = await fetch(url, {
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify(data)
			});
			if (!response.ok) {
				throw new Error('请求失败: ' + response.status);
			}
			return response.json();
		},
		async handleSearch() {
			this.tableLoading = true;
			const userId = this.userId;
			if (!userId || userId === 0) {
				this.$message.error('用户未登录或用户ID无效');
				this.tableLoading = false;
				return;
			}
			try {
				let pageSize;
				if (!this.pageSizeInput || this.pageSizeInput.trim() === '') {
					pageSize = 10;
					this.pageSizeInput = '10';
				} else {
					pageSize = parseInt(this.pageSizeInput, 10);
					if (isNaN(pageSize) || pageSize < 1) {
						pageSize = 1;
						this.pageSizeInput = '1';
					} else if (pageSize > 1000) {
						pageSize = 1000;
						this.pageSizeInput = '1000';
					}
				}
				this.pageSize = pageSize;

				const result = await this.apiRequest('/query_orders', this.buildRequestData(this.currentPage, this.pageSize));
				if (result.code === 200) {
					this.orderTableData = this.formatOrderData(result.data.orders || []);
					this.total = (result.data.pagination || {}).total || 0;
					if (this.orderTableData.length === 0) {
						this.$message.info('未找到符合条件的订单');
					}
				} else {
					this.$message.error(result.msg || '查询失败');
					this.orderTableData = [];
					this.total = 0;
				}
			} catch (error) {
				console.error('查询订单失败:', error);
				this.$message.error('网络错误或服务器异常，请稍后重试');
				this.orderTableData = [];
				this.total = 0;
			} finally {
				this.tableLoading = false;
			}
		},
		buildRequestData(page, pageSize) {
			const createRange = this.searchForm.create_time_range || [];
			const trackStartRange = this.searchForm.track_start_time_range || [];
			const requestData = {
					merchant_order_no: this.searchForm.merchant_order_no || '',
					track_number: this.searchForm.track_number || '',
					track_type: this.searchForm.track_type || 0,
					route_type: (this.searchForm.route_type === undefined || this.searchForm.route_type === '')
						? -1 : this.searchForm.route_type,
					push_track: (this.searchForm.push_track === undefined || this.searchForm.push_track === '')
						? -1 : this.searchForm.push_track,
					order_status: this.searchForm.order_status || 0,
					create_time_start: createRange[0] || '',
					create_time_end: createRange[1] || '',
					track_start_time_start: trackStartRange[0] || '',
					track_start_time_end: trackStartRange[1] || '',
					track_end_time_start: '',
					track_end_time_end: '',
					user_id: this.userId,
					page: page,
					page_size: pageSize
			};
			if (this.activeTab !== '0') {
				requestData.order_status = parseInt(this.activeTab, 10);
			}
			return requestData;
		},
		async handleExport() {
			if (this.exporting) return;
			// 未勾选订单时，先提示将导出全部
			if (this.selectedOrders.length === 0) {
				try {
					await this.$confirm('未勾选订单，将导出当前查询条件下的全部订单，是否继续？', '提示', {
						confirmButtonText: '继续导出',
						cancelButtonText: '取消',
						type: 'warning'
					});
				} catch (e) {
					return; // 用户取消
				}
			}
			this.exporting = true;
			try {
				const trackTypeNames = { 1: 'JCEX', 2: 'JS', 3: 'PIGGY' };
				const statusNames = { 0: '全部订单', 1: '待确认单', 2: '手动签收单', 3: '待签收', 4: '自动签收单', 5: '已取消' };
				const rowOf = (o) => [
					o.merchantOrderNo || o.merchant_order_no || '',
					o.providerOrderNo || o.track_num || '',
					trackTypeNames[parseInt(o.orderType || o.track_type, 10)] || o.orderType || o.track_type,
					o.routeTypeName || o.route_type_name || this.getRouteName(o.route_type),
					(o.formattedSenderAddress && o.formattedSenderAddress.fullAddress)
						? o.formattedSenderAddress.fullAddress : (o.senderAddress || ''),
					(o.formattedReceiverAddress && o.formattedReceiverAddress.fullAddress)
						? o.formattedReceiverAddress.fullAddress : (o.receiverAddress || ''),
					this.getPushTrackText(o.pushTrack != null ? String(o.pushTrack) : '-'),
					statusNames[parseInt(o.status || o.order_status, 10)] || o.status || o.order_status,
					o.createTime || fmtDateTime(o.create_time),
					o.trackStartTime || fmtDateTime(o.track_start_time),
					o.trackEndTime || fmtDateTime(o.track_end_time),
					o.remark || ''
				];
				let all;
				if (this.selectedOrders.length > 0) {
					// 有选中：只导出选中的订单
					all = this.selectedOrders.map(rowOf);
				} else {
					// 没有选中：导出当前筛选条件下的全部订单
					all = [];
					let page = 1;
					let lastCount = 100;
					do {
						const result = await this.apiRequest('/query_orders', this.buildRequestData(page, 100));
						const d = result.data || {};
						const orders = d.orders || [];
						all = all.concat(orders.map(rowOf));
						lastCount = orders.length;
						page++;
						// 某页不足 100 条说明已到最后一页（不依赖 total，兼容后端分页统计差异）
					} while (lastCount === 100 && page <= 1000);
				}
				exportCSV('订单列表_' + Date.now() + '.csv',
					['商户订单号', '服务商单号', '物流商', '物流线路', '发货地址', '收货地址', '轨迹推送状态', '单号类型', '创建时间', '轨迹开始时间', '轨迹结束时间', '备注'],
					all);
			} catch (e) {
				this.$message.error('导出失败：' + e.message);
			} finally {
				this.exporting = false;
			}
		},
		applyStatusTab(key) {
			const statusMap = {
				'0': 0,
				'1': 1,
				'2': 2,
				'3': 3,
				'4': 4,
				'5': 5
			};
			this.searchForm.order_status = statusMap[key] || 0;
			this.currentPage = 1;
			this.handleSearch();
		},
		handleReset() {
			this.searchForm = {
				merchant_order_no: '',
				track_number: '',
				track_type: 0,
				route_type: -1,
				push_track: -1,
				order_status: 0,
				create_time_range: [],
				track_start_time_range: []
			};
			this.pageSizeInput = '';
			this.pageSize = 10;
			this.currentPage = 1;
			this.$emit('reset');
			if (this.activeTab === '0') {
				this.handleSearch();
			}
		},
		handlePageSizeInput(value) {
			this.pageSizeInput = value.replace(/[^\d]/g, '');
			if (this.pageSizeInput) {
				const num = parseInt(this.pageSizeInput, 10);
				if (num < 1) {
					this.pageSizeInput = '1';
				} else if (num > 1000) {
					this.pageSizeInput = '1000';
				}
			}
		},
		handleCurrentChange(val) {
			this.currentPage = val;
			this.handleSearch();
		},
		handleSelectionChange(selection) {
			this.selectedOrderIds = selection.map(item => item.id);
			this.selectedOrders = selection;
		},
		formatOrderData(orders) {
			if (!orders || !Array.isArray(orders)) {
				return [];
			}
			return orders.map(order => {
				const orderStatus = order.order_status != null ? String(order.order_status) : '0';
				const shippingCountry = this.extractCountryFromAddress(order.shipping_address);
				const receivingCountry = this.extractCountryFromAddress(order.receiving_address);
				return {
					id: order.id,
					merchantOrderNo: order.merchant_order_no || '',
					providerOrderNo: order.track_num || '',
					orderType: order.track_type != null ? String(order.track_type) : '0',
					pushTrack: order.push_track != null ? String(order.push_track) : '-',
					route_type: order.route_type != null ? parseInt(order.route_type, 10) : null,
					routeTypeName: order.route_type_name || this.getRouteName(order.route_type),
					senderAddress: order.shipping_address || '',
					formattedSenderAddress: this.parseAddress(order.shipping_address, shippingCountry),
					receiverAddress: order.receiving_address || '',
					formattedReceiverAddress: this.parseAddress(order.receiving_address, receivingCountry),
					status: orderStatus,
					createTime: fmtDateTime(order.create_time),
					trackStartTime: fmtDateTime(order.track_start_time),
					trackEndTime: fmtDateTime(order.track_end_time),
					remark: order.remark || '',
					shippingCountry: shippingCountry,
					receivingCountry: receivingCountry
				};
			});
		},
		getRouteName(routeType) {
			const map = {
				0: '美国-美国',
				1: '英国-英国',
				2: '加拿大-加拿大',
				3: '中国-全球'
			};
			return map[parseInt(routeType, 10)] || '未知';
		},
		getRouteTagType(routeType) {
			switch (parseInt(routeType, 10)) {
				case 0:
					return 'primary';
				case 1:
					return 'success';
				case 2:
					return 'warning';
				case 3:
					return 'danger';
				default:
					return 'info';
			}
		},
		extractCountryFromAddress(address) {
			if (!address || typeof address !== 'string') {
				return '';
			}
			const parts = address.split(',');
			if (parts.length > 0) {
				return parts[0].trim();
			}
			return '';
		},
		parseAddress(addressString, countryCode = '') {
			if (!addressString || typeof addressString !== 'string') {
				if (countryCode) {
					return {
						country: countryCode,
						state: '-',
						city: '-',
						zipcode: '-',
						address: '-',
						fullAddress: countryCode
					};
				}
				return null;
			}
			const parts = addressString.split(',').map(part => part.trim());
			let country = '';
			let state = '-';
			let city = '-';
			let zipcode = '-';
			let address = '-';
			if (parts.length >= 1 && parts[0]) country = parts[0];
			if (parts.length >= 2 && parts[1]) state = parts[1];
			if (parts.length >= 3 && parts[2]) city = parts[2];
			if (parts.length >= 4 && parts[3]) zipcode = parts[3];
			if (parts.length >= 5) {
				address = parts.slice(4).join(', ');
			}
			if (!country && countryCode) country = countryCode;
			const fullAddress = [country, state, city, zipcode, address]
				.filter(part => part && part !== '-')
				.join(', ');
			return {
				country: country,
				state: state,
				city: city,
				zipcode: zipcode,
				address: address,
				fullAddress: fullAddress
			};
		},
		getStatusTagType(status) {
			switch (status) {
				case '1':
					return 'warning';
				case '2':
					return 'primary';
				case '3':
					return 'info';
				case '4':
					return 'success';
				case '5':
					return 'danger';
				default:
					return '';
			}
		},
		getStatusText(status) {
			const statusMap = {
				'0': '全部订单',
				'1': '待确认单',
				'2': '手动签收单',
				'3': '待签收',
				'4': '自动签收单',
				'5': '已取消'
			};
			return statusMap[status] || '未知状态';
		},
		getPushTrackTagType(pushTrack) {
			switch (pushTrack) {
				case '0':
					return 'info';
				case '1':
					return 'success';
				case '2':
					return 'danger';
				default:
					return '';
			}
		},
		getPushTrackText(pushTrack) {
			const pushTrackMap = {
				'0': '未推送',
				'1': '推送成功',
				'2': '推送失败'
			};
			return pushTrackMap[pushTrack] || '未知';
		},
		getLinkUrl(orderNo) {
			if (!orderNo) return 'javascript:void(0);';
			return `https://track.jcex.com/?nums=${orderNo}`;
		}
	}
};
</script>

<style scoped>
.search-input.date-time-range {
	grid-column: span 2;
	min-width: 0;
}

.search-input.date-time-range.el-date-editor--datetimerange {
	width: 100% !important;
}

.reset-btn.export-btn {
	background: #eaf4ff !important;
	border: 1px solid #a8c8f5 !important;
	color: #4a90e2 !important;
}
.reset-btn.export-btn:hover {
	background: #dcecff !important;
}
</style>
